module.exports = __webpack_public_path__ + "img/title.aac07f0f.jpg";